import { match } from 'ts-pattern'

import { useDirectTask } from './useDirectTask'

enum Casing {
  DEFAULT = 'default', // whatever it was typed/received as
  LOWERCASE = 'lowercase', // your employer
  TITLECASE = 'titlecase', // Your Employer
}

type Props = {
  casing?: Casing
  possessive?: boolean
}

export function useEmployerTitle(): {
  getEmployerTitle: (props?: Props) => string
} {
  const task = useDirectTask()

  function getTitle(possessive = false): string {
    const default_title = possessive ? 'your employer' : 'employer'

    const employerNameExists = task && task.employer_name
    if (employerNameExists && task.is_external_employment) {
      return `${task.employer_name}`
    }

    return default_title
  }

  function withCasing(casing: Casing, title: string): string {
    return match(casing)
      .with(Casing.DEFAULT, () => title)
      .with(Casing.LOWERCASE, () => title.toLowerCase())
      .with(Casing.TITLECASE, () => {
        const parts = title.split(' ')
        return parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(' ')
      })
      .exhaustive()
  }

  return {
    getEmployerTitle: ({ casing, possessive }: Props = { possessive: false }): string => {
      const title = getTitle(possessive)
      if (casing) {
        return withCasing(casing, title)
      }
      return withCasing(Casing.DEFAULT, title)
    },
  }
}
